import invert from 'lodash/invert';
import generatedTradableAssetMap from '../../generated/generatedTradableAssetMap.json';
const thorPoolIdAssetIdSymbolMap = generatedTradableAssetMap;
export const assetIdToThorPoolAssetIdMap = invert(thorPoolIdAssetIdSymbolMap);
export const thorPoolAssetIdToAssetId = (id) => thorPoolIdAssetIdSymbolMap[id.toUpperCase()];
export const assetIdToThorPoolAssetId = ({ assetId }) => assetIdToThorPoolAssetIdMap[assetId.toLowerCase()];
